/*
 *  -----------------------------------------------------------------------
 *    <copyright file="modules.ts" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import { Permissions } from 'contexts/user-context';

export interface IModuleElementOption {
    display: string;
    value: number;
}

export interface IModuleElement {
    name: string;
    display: string;
    options: IModuleElementOption[];
}

export interface IModule {
    id: string;
    value: number;
    elements?: IModuleElement[];
}

export interface IModules {
    CentralMonitoring: IModule;
    RiskAssessment: IModule;
    CentralMonitoring2: IModule;
    SubjectMonitoring: IModule;
    DataQuality: IModule;
}

const ViewCreateEditDeletePermissions = [
    { display: 'view', value: Permissions.Read },
    { display: 'create', value: Permissions.ReadWrite },
    { display: 'edit', value: Permissions.ReadWrite },
    { display: 'delete', value: Permissions.ReadWrite },
];

const OnOffPermissions = [{ display: 'enabled', value: Permissions.Enabled }];

const Modules: IModules = {
    CentralMonitoring: { id: 'CM', value: 0x01 },
    RiskAssessment: {
        id: 'RAM',
        value: 0x02,
        elements: [
            {
                name: 'risks',
                display: 'ra:risks',
                options: ViewCreateEditDeletePermissions,
            },
            {
                name: 'risk-library',
                display: 'ra:riskLibrary',
                options: ViewCreateEditDeletePermissions.filter((p) => p.value !== Permissions.Read), // Everything except view
            },
            {
                name: 'critical-variables',
                display: 'ra:criticalVariables',
                options: ViewCreateEditDeletePermissions,
            },
        ],
    },
    CentralMonitoring2: { id: 'CM2', value: 0x08 },
    SubjectMonitoring: { id: 'SM', value: 0x10 },
    DataQuality: { id: 'DQ', value: 0x20 },
};

export default Modules;
